import type { GradePublic } from '@repo/types/grades';

import { cn } from '@repo/lib/cn';
import { format } from 'date-fns';
import { ArrowUpRight, Dot } from 'lucide-react';
import { Link } from 'react-router';

import GradeValuePill from '@/components/features/grades/GradeValuePill';
import { Badge } from '@/components/ui/badge';
import { useGradeOriginLink } from '@/hooks/grade';

import { GRADE_ORIGIN_CONFIG } from './gradeOrigin';

interface GradeDetailsContentProps {
  grade: GradePublic;
  className?: string;
}

export default function GradeDetailsContent({ grade, className }: GradeDetailsContentProps) {
  const origin = useGradeOriginLink(grade);
  const createdAt = new Date(grade.createdAt);
  const originConfig = GRADE_ORIGIN_CONFIG[grade.originType];

  return (
    <>
      <div className={cn('flex w-full flex-col gap-3.5 px-4 pb-4', className)}>
        <GradeValuePill grade={grade} size={'lg'} />

        {grade.desc && (
          <div className={'flex w-full flex-col gap-1.5'}>
            <span className={'text-muted-foreground text-xs font-medium'}>Opis</span>
            <p className={'text-foreground text-sm'}>{grade.desc}</p>
          </div>
        )}

        {grade.originType !== 'other' && (
          <div className={'flex flex-col gap-1.5'}>
            <span className={'text-muted-foreground text-xs font-medium'}>Typ:</span>
            <Badge variant={'warning'} size={'sm'} border className={'pointer-events-none'}>
              {originConfig.label}
            </Badge>
          </div>
        )}
        {origin && (
          <div className={'flex flex-col gap-1.5'}>
            <span className={'text-muted-foreground text-xs font-medium'}>Powiązana aktywność:</span>
            <Badge asChild variant={'outline'} border size={'sm'}>
              <Link to={origin.to}>
                Pokaż szczegóły
                <ArrowUpRight />
              </Link>
            </Badge>
          </div>
        )}
      </div>

      <div className={'bg-accent border-border-primary text-muted-foreground flex w-full items-center justify-end border-t p-4 text-sm'}>
        {format(createdAt, 'd MMM yyyy')}
        <Dot className={'size-4'} />
        {format(createdAt, 'HH:mm')}
      </div>
    </>
  );
}
